const lang = {
  uk: {
    loading: "Завантаження...",
    theLessonIsNotYetPaid: "Неоплачений урок 😔",
    rotateYourDevice: "Поверніть екранчиком поземо",
  },
  en: {
  },
};

export default lang["uk"];
